import type { PropType } from 'virtual-vue';
import type { ScrollViewScrollConfig } from './scroll-view';

export const DEFAULT_SCROLL_VIEW_SCROLL_X = false;
export const DEFAULT_SCROLL_VIEW_SCROLL_Y = true;
export const DEFAULT_SCROLL_VIEW_SCROLL_TOP = 0;
export const DEFAULT_SCROLL_VIEW_SCROLL_LEFT = 0;
export const DEFAULT_SCROLL_VIEW_SCROLL_WITH_ANIMATION = false;
export const DEFAULT_SCROLL_VIEW_LOWER_THRESHOLD = 0;
export const DEFAULT_SCROLL_VIEW_UPPER_THRESHOLD = 0;
export const DEFAULT_SCROLL_VIEW_SCROLL_CONFIG: ScrollViewScrollConfig = 'default';
export const DEFAULT_SCROLL_VIEW_SHOW_SCROLLBAR = false;
export const DEFAULT_SCROLL_VIEW_CLASS = '';
export const DEFAULT_SCROLL_VIEW_STYLE = '';

/**
 * 组件的props
 * 基于方案设计文档生成
 */
export const props = {
  /**
   * 允许横向滚动
   * @default false
   */
  scrollX: {
    type: Boolean,
    default: DEFAULT_SCROLL_VIEW_SCROLL_X,
  },
  /**
   * 允许纵向滚动
   * @default true
   */
  scrollY: {
    type: Boolean,
    default: DEFAULT_SCROLL_VIEW_SCROLL_Y,
  },
  /**
   * 设置竖向滚动条位置
   * @default 0
   */
  scrollTop: {
    type: [Number, String] as PropType<number | string>,
    default: DEFAULT_SCROLL_VIEW_SCROLL_TOP,
  },
  /**
   * 设置横向滚动条位置
   * @default 0
   */
  scrollLeft: {
    type: [Number, String] as PropType<number | string>,
    default: DEFAULT_SCROLL_VIEW_SCROLL_LEFT,
  },
  /**
   * 在设置滚动条位置时使用动画过渡
   * @default false
   */
  scrollWithAnimation: {
    type: Boolean,
    default: DEFAULT_SCROLL_VIEW_SCROLL_WITH_ANIMATION,
  },
  /**
   * 距底部/右边多远时，触发 scrolltolower 事件
   * @default 0
   */
  lowerThreshold: {
    type: Number,
    default: DEFAULT_SCROLL_VIEW_LOWER_THRESHOLD,
  },
  /**
   * 距顶部/左边多远时，触发 scrolltoupper 事件
   * @default 0
   */
  upperThreshold: {
    type: Number,
    default: DEFAULT_SCROLL_VIEW_UPPER_THRESHOLD,
  },
  /**
   * 设置惯性滚动等特性（仅 LiteApp）
   * @default 'default'
   */
  scrollConfig: {
    type: String as PropType<ScrollViewScrollConfig>,
    default: DEFAULT_SCROLL_VIEW_SCROLL_CONFIG,
  },
  /**
   * 控制滚动条显隐
   * @default false
   */
  showScrollbar: {
    type: Boolean,
    default: DEFAULT_SCROLL_VIEW_SHOW_SCROLLBAR,
  },
  /**
   * 自定义类名
   */
  class: {
    type: String,
    default: DEFAULT_SCROLL_VIEW_CLASS,
  },
  /**
   * 自定义样式
   */
  style: {
    type: [String, Object] as PropType<string | Record<string, any>>,
    default: DEFAULT_SCROLL_VIEW_STYLE,
  },
};


